<template>
	<span v-test="'review-stars'" class="d-inline-flex align-center review-stars" role="img" :aria-label="ariaLabel">
		<v-icon
			v-for="position in MAX_RATING"
			:key="position"
			:icon="position <= filledCount ? 'mdi-star' : 'mdi-star-outline'"
			:size="size"
			:color="position <= filledCount ? 'amber-darken-2' : 'grey-lighten-1'"
			aria-hidden="true" />
	</span>
</template>

<script setup lang="ts">
	import { computed } from "vue";

	// LSP-21829: the read-only star row shared by the Reviews page (table and cards) and the About tab's
	// Customer Review section. Ratings are whole stars from 1 to 5.
	const MAX_RATING = 5;

	const props = withDefaults(defineProps<{ rating: number | null | undefined; size?: string | number }>(), { size: "small" });

	const filledCount = computed(() => {
		const rating = Number(props.rating);
		return Number.isFinite(rating) ? Math.max(0, Math.min(MAX_RATING, Math.round(rating))) : 0;
	});
	const ariaLabel = computed(() => `${filledCount.value} out of ${MAX_RATING} stars`);
</script>
